import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import axios from 'axios'
import DashboardNavbar from '../components/Header';
 
const TableContainer = styled.div`
  background: #f5f5f5;
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 75px 0 0 0;
  box-sizing: border-box;
  padding-top: 0px;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 0;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  width: 100%;
  max-width: 1100px;
  border: 1px solid #b2c8b2;
  margin: 0 auto;
  overflow-x: auto;
`;

const SectionHeader = styled.div`
  background: #8ab7a6;
  color: #fff;
  font-weight: bold;
  font-size: 1.1rem;
  text-align: center;
  padding: 12px 0;
  border-bottom: 1px solid #b2c8b2;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  min-width: 900px;
`;

const StyledThead = styled.thead`
  background: #8ab7a6;
`;

const StyledTh = styled.th`
  color: #fff;
  padding: 12px 8px;
  font-weight: 600;
  text-transform: uppercase;
  border: 1px solid #b2c8b2;
  text-align: center;
  font-size: 1rem;
  min-width: 100px;
`;

const StyledTd = styled.td`
  padding: 10px 8px;
  text-align: center;
  color: #222;
  font-size: 1rem;
  border: 1px solid #b2c8b2;
  background: #fff;
  word-break: break-word;
  min-width: 100px;
`;

const StyledTr = styled.tr`
  background: #fff;
`;

const History = () => {
  const [userData, setUserData] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      setUserData(JSON.parse(user));
    } else {
      alert("User is not logged in. Please log in to view your bets.");
    }
  }, []);

  const fetchBets = async () => {
    if (userData) {
      try {
        const userId = userData.userNo;
        console.log(userId)
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/getuserdepositeandwidhrwallist/${userId}`);
        if (response.data.success) {
          setData(response.data.data);
        } else {
          alert("Failed to fetch bets");
        }
      } catch (err) {
        console.error('Error fetching bets:', err);
      }
    }
  };

  useEffect(() => {
    if (userData) {
      fetchBets();
    }
  }, [userData]);

  return (
    <>
      <DashboardNavbar/>
      <TableContainer>
        <Card>
          {/* <SectionHeader>CRICKET HISTORY</SectionHeader> */}
          <StyledTable style={{width: '100%'}}>
            <StyledThead>
              <tr>
                {['ClientId', 'AgentId', 'Deposit', 'Withdrawal', 'Balance', 'Time'].map((head, index) => (
                  <StyledTh key={index}>{head}</StyledTh>
                ))}
              </tr>
            </StyledThead>
            <tbody>
              {[...data].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((bet, index) => (
                <StyledTr key={index}>
                  <StyledTd>{bet.userNo}</StyledTd>
                  <StyledTd>{bet.agentNo}</StyledTd> 
                  <StyledTd style={{background: bet.deposit > 0 ? '#28a745' : undefined, color: bet.deposit > 0 ? '#fff' : undefined}}>{bet.deposit}</StyledTd>
                  <StyledTd style={{background: bet.withdrawal > 0 ? '#dc3545' : undefined, color: bet.withdrawal > 0 ? '#fff' : undefined}}>{bet.withdrawal}</StyledTd>
                  <StyledTd>{bet.currentBalance}</StyledTd>
                  <StyledTd>{new Date(bet.createdAt).toLocaleString()}</StyledTd> 
                </StyledTr>
              ))}
            </tbody>
          </StyledTable>
        </Card>
      </TableContainer>
    </>
  );
};

export default History;
